import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: 'Search',
});
